module.exports = __webpack_public_path__ + "static/media/ic-youtube.85176897.svg";